import { ApolloProvider } from "@apollo/client";
import * as Sentry from "@sentry/react";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import "./index.css";
import { worker } from "./mocks/browser";
import { AuthProvider, useAuth } from "@/auth/AuthProvider";
import { apolloClient } from "@/lib/apollo-client";
import { createRouter } from "@/router";
import { store } from "@/store/store";

const root = document.getElementById("root");
const router = createRouter();

if (import.meta.env.VITE_ENABLE_MSW === "true") {
  worker
    .start({
      onUnhandledRequest: "bypass",
    })
    .catch((e) => {
      console.error("❌ MSW initialization failed:", e);
    });
}

Sentry.init({
  dsn: "https://60b0d2283da0cb770c49b7c23d1f79aa@o366744.ingest.us.sentry.io/4508677070520320",
  integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],
  tracesSampleRate: 1.0,
  environment: import.meta.env.VITE_BUILD_ENV,
  enabled: ["production", "staging", "development"].includes(import.meta.env.VITE_BUILD_ENV),
});

function App() {
  const auth = useAuth();

  return <RouterProvider router={router} context={{ auth }} />;
}

createRoot(root!).render(
  <StrictMode>
    <ReduxProvider store={store}>
      <ApolloProvider client={apolloClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ApolloProvider>
    </ReduxProvider>
  </StrictMode>,
);
